import cx from 'classnames';

import styles from './noData.module.scss';
import DocumentSearchIcon from '../assets/svgs/document-search.svg';

const NoData = () => {
  return (
    <div className={cx(styles.wrapper, styles.noList)}>
      <div className={styles.center}>
        <DocumentSearchIcon />
        <p>No data found</p>
      </div>
    </div>
  );
};

export default NoData;
